<nz-modal [(nzVisible)]="isVisibleSiteDrawer"
    [nzClassName]="this.tabIndex == 0 ? 'siteModal site-edit-modal' : 'siteModal-othertab site-edit-modal'"
    [nzTitle]="siteNameTitleTemplate" (nzOnCancel)="handleCancel()" [nzFooter]="footerTpl">
    <ng-template #siteNameTitleTemplate>
        <div>
            Site : {{ SelectedSiteTab == SiteType.Supplier ? selectedSiteName : this._fS.siteForm.value.siteName}}
        </div>
    </ng-template>
    <ng-container *nzModalContent class="h-100">
        <!-- style="overflow: auto; height: 75vh" -->
        <div>
            <nz-tabset (nzSelectedIndexChange)="tabEvent($event)" [(nzSelectedIndex)]="tabIndex">
                <nz-tab nzTitle="Details">
                    <div class="page-padding" style="overflow: auto;max-height: calc(100vh - 16em);">
                        <div nz-row class="d-flex align-i-c">
                            <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                                <h1 class="page-title-text tab-title">Details</h1>
                            </div>
                        </div>
                        <div class="detail-box" nz-row>
                            <div nz-col nzSpan="24" class="section-top-padding">
                                <form nz-form [formGroup]="_fS.siteForm">
                                    <div nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                                        <div nzSpan="24">
                                            <p class="site-logo-text">Site logo</p>
                                        </div>
                                        <div class="upload" nz-col nzSpan="24">
                                            <nz-avatar nzIcon="user" [nzSize]="94" (click)="file.click()"
                                                (change)="onFileChanged($event)"
                                                [nzSrc]="this.uploadResult ? this.uploadResult : null">
                                            </nz-avatar>

                                            <div nzMultiple="false" (click)="file.click()"
                                                (change)="onFileChanged($event)">
                                                <button nz-button nzMultiple="false" [nzLoading]="isLoadingUpload"
                                                    class="update-logo-btn">
                                                    <i nz-icon nzType="camera" nzTheme="outline"></i>
                                                    Add/Update Logo
                                                </button>
                                            </div>
                                            <input autocomplete="off" type="file" (change)="onFileChanged($event)" #file
                                                hidden nzTooltipTitle="prompt text" multiple
                                                (click)="Onclick($event)" />
                                            <a *ngIf="this.uploadResult" nz-popconfirm
                                                nzPopconfirmTitle="Are you sure you want to delete the logo?"
                                                nzPopconfirmPlacement="bottom" (nzOnConfirm)="removeLogo()"><img
                                                    src="../../../../assets/images/delete.png"
                                                    class="delete-File ml-1" />
                                            </a>
                                        </div>
                                        <div nz-col nzSpan="12">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="siteNameError">
                                                    <label class="label-text required">Site name</label>
                                                    <input *ngIf="SelectedSiteTab != SiteType.Supplier"
                                                        class="input-group" nz-input formControlName="siteName"
                                                        [(ngModel)]="siteNameModel" pattern="^(?!\s+$).+" minlength="2"
                                                        maxlength="100"
                                                        (keypress)="_cS.checkAlphabetsWithSpaceCommaNumbers($event)" />

                                                    <nz-select *ngIf="SelectedSiteTab == SiteType.Supplier" nzShowSearch
                                                        nzPlaceHolder="Select Site Name" [nzDisabled]="selectedSiteData"
                                                        [(ngModel)]="siteNameModel"
                                                        (ngModelChange)="siteNameChange($event)" [nzSize]="'default'"
                                                        formControlName="siteName" [nzSelectOnTab]="true">
                                                        <nz-option *ngFor="let option of listOfQBOCustomers"
                                                            [nzDisabled]="option.isInvestorSelected"
                                                            [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
                                                    </nz-select>
                                                    <ng-template #siteNameError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            state
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid
                                                            state
                                                        </ng-container>
                                                    </ng-template>
                                                    <ng-template #siteNameError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            site name
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('minlength')">Site name
                                                            {{validationMessage.minlength}}
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('pattern')">Please enter
                                                            site name</ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>

                                        <div nz-col nzSpan="12">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="accountNameError">
                                                    <label class="label-text required">Account
                                                        name</label>
                                                    <nz-select nzShowSearch nzPlaceHolder="Select Account"
                                                        (nzOpenChange)="getAccountDetails()" [nzSize]="'default'"
                                                        formControlName="accountName" [nzSelectOnTab]="true"
                                                        (ngModelChange)="focusAddress($event)">
                                                        <nz-option *ngFor="let option of listOfAccounts"
                                                            [nzLabel]="option.name" [nzValue]="option.name"></nz-option>
                                                    </nz-select>
                                                    <ng-template #accountNameError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please select
                                                            account
                                                        </ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                        <div nz-col nzSpan="24" *ngIf="SelectedSiteTab != SiteType.Supplier">
                                            <label class="" nz-checkbox formControlName="isSameAddress"
                                                [(ngModel)]="isSameAddressFlag"
                                                (ngModelChange)="getAccountDetails()">Same as Account</label>
                                        </div>
                                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12"
                                            *ngIf="!LineStreetAddress">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="address1Error">
                                                    <label class="label-text required">Address 1</label>
                                                    <input #address1Field class="input-group" nz-input
                                                        formControlName="address1" minlength="2" maxlength="100" />
                                                    <ng-template #address1Error let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            address 1</ng-container>
                                                        <ng-container *ngIf="control.hasError('minlength')">Address
                                                            {{validationMessage.minlength}}
                                                        </ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                            <div (click)="addLines()">
                                                <span nz-icon nzType="down" nzTheme="outline"></span><label>Add
                                                    lines</label>
                                            </div>
                                        </div>
                                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12"
                                            *ngIf="!LineStreetAddress">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <!-- <label class="label-text required">Address 2</label> -->
                                                    <label class="label-text">Address 2</label>
                                                    <input class="input-group" nz-input formControlName="address2"
                                                        minlength="2" maxlength="100" />
                                                    <!-- <ng-template #address2Error let-control>
                                                    <ng-container *ngIf="control.hasError('required')">Please enter Address 2</ng-container>
                                                    <ng-container *ngIf="control.hasError('minlength')">Address must contain at least 2
                                                        characters
                                                    </ng-container>
                                                </ng-template> -->
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="24"
                                            *ngIf="LineStreetAddress">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="streetAError">
                                                    <label class="label-text required">Street address</label>
                                                    <textarea type="text"
                                                        pattern="^[A-Z-a-z0-9,./#@'?^*%$&!;:-_()+=&quot;{}|\n\s][A-Z-a-z0-9 ,./#@'?^*%$&!;:-_()+=&quot;{}|\s\r\n]{1,150}$"
                                                        class="input-group" nz-input formControlName="address1"
                                                        maxlength="1000" minlength="2"></textarea>
                                                    <ng-template #streetAError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            street address
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('pattern')">Street address
                                                            {{validationMessage.minlength}}</ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="citytownError">
                                                    <label class="label-text required">City/Town</label>
                                                    <input class="input-group" nz-input formControlName="city"
                                                        [readonly]="SelectedSiteTab != SiteType.Supplier && this.isSameAddressFlag" />
                                                    <ng-template #citytownError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            city/town
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid
                                                            city/town
                                                        </ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>


                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="stateError">
                                                    <label class="label-text required">State</label>
                                                    <nz-select nzShowSearch nzPlaceHolder="Select State"
                                                        [nzDisabled]="SelectedSiteTab != SiteType.Supplier && this.isSameAddressFlag"
                                                        [nzSize]="'default'" formControlName="state"
                                                        [nzSelectOnTab]="true" (ngModelChange)="focusZipCode($event)">
                                                        <nz-option *ngFor="let option of listOfStates"
                                                            [nzLabel]="option" [nzValue]="option"></nz-option>
                                                    </nz-select>
                                                    <ng-template #stateError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            state
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid
                                                            state
                                                        </ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>


                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="zipcodeError">
                                                    <label class="label-text required">Zip code</label>
                                                    <input #zipcode class="input-group" nz-input
                                                        formControlName="zipcode"
                                                        [readonly]="SelectedSiteTab != SiteType.Supplier && this.isSameAddressFlag"
                                                        minlength="5" (keypress)="_cS.checkNumbers($event)"
                                                        mask="00000||00000-0000" />
                                                    <ng-template #zipcodeError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            zip
                                                            code
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid
                                                            zip
                                                            code
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('minlength')">Zip code
                                                            must contain at least 5
                                                            digits
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="_fS.siteForm.get('zipcode')?.value?.length > 5 && _fS.siteForm.get('zipcode')?.value?.length < 9">Please
                                                            enter valid zipcode (XXXXX-XXXX or XXXXX)
                                                        </ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>

                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="countryError">
                                                    <label class="label-text required">Country</label>
                                                    <input class="input-group" nz-input formControlName="country"
                                                        [readonly]="SelectedSiteTab != SiteType.Supplier && this.isSameAddressFlag" />
                                                    <ng-template #countryError let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                                            country
                                                        </ng-container>
                                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid
                                                            country
                                                        </ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control [nzErrorTip]="siteTypeErr">
                                                    <label class="label-text required">Site Type</label>
                                                    <nz-select nzShowSearch nzPlaceHolder="Select Site Type"
                                                        [nzSize]="'default'" formControlName="siteType"
                                                        [nzSelectOnTab]="true">
                                                        <nz-option *ngFor="let option of listOfSiteTypes"
                                                            [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
                                                    </nz-select>
                                                    <ng-template #siteTypeErr let-control>
                                                        <ng-container *ngIf="control.hasError('required')">Please select
                                                            site type
                                                        </ng-container>
                                                    </ng-template>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>

                                        <ng-container *ngIf="SelectedSiteTab == SiteType.Supplier">
                                            <div nz-col nzSpan="18">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="dateError">
                                                        <label class="label-text required">Date</label>
                                                        <mat-form-field
                                                            [ngClass]="isDateError || invalidDate ? 'invalidMatField' : ''"
                                                            class="matDateField">
                                                            <input type="hidden" formControlName="date"
                                                                [matDatepicker]="pickerMat" placeholder="Choose a date"
                                                                [max]="maxSiteDate" [min]="minSiteDate"
                                                                (dateChange)="todate($event.value)"
                                                                (ngModelChange)="_fS.siteForm.value.date ? isDateError = false : ''">
                                                            <input matInput type="text" [textMask]="mask"
                                                                [ngModel]="_fS.siteForm.get('date').value | date : _fS.siteForm.get('date').value !== null ?'MM/dd/yyyy' : ''"
                                                                [ngModelOptions]="{standalone: true}"
                                                                (ngModelChange)="todate($event)" />
                                                            <mat-hint>MM/DD/YYYY</mat-hint>
                                                            <mat-datepicker-toggle matSuffix [for]="pickerMat">
                                                            </mat-datepicker-toggle>
                                                            <mat-datepicker #pickerMat></mat-datepicker>
                                                        </mat-form-field>
                                                        <ng-template #dateError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                enter
                                                                date
                                                            </ng-container>

                                                        </ng-template>
                                                        <p *ngIf="invalidDate" style="color:red; font-size: 12px;">Date
                                                            must
                                                            be between 01/01/2010 to 12/31/2050
                                                        </p>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                            <div nz-col nzSpan="12">
                                                <label class="label-text required">Site</label>
                                                <div nz-col nzSpan="8">
                                                    <nz-form-item>
                                                        <nz-form-control [nzErrorTip]="statusError">

                                                            <nz-radio-group formControlName="status">
                                                                <label nz-radio nzValue="1">Visible</label>
                                                                <label nz-radio nzValue="0">Hidden</label>
                                                            </nz-radio-group>
                                                            <ng-template #statusError let-control>
                                                                <ng-container
                                                                    *ngIf="control.hasError('required')">Please
                                                                    select
                                                                    status
                                                                </ng-container>
                                                            </ng-template>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <div nz-col nzSpan="24" *ngIf="SelectedSiteTab != SiteType.Supplier">
                                            <div class="border-top"></div>
                                        </div>
                                        <div nz-col nzSpan="12">
                                            <label class="sub-form-title"
                                                *ngIf="SelectedSiteTab != SiteType.Supplier">All Transaction</label>
                                        </div>
                                        <div nz-col nzSpan="12">
                                            <label class="sub-form-title"
                                                *ngIf="SelectedSiteTab != SiteType.Supplier">Bills(Payments)</label>
                                        </div>


                                        <ng-container *ngIf="SelectedSiteTab != SiteType.Supplier">
                                            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="classError">
                                                        <div class="d-flex align-i-c">
                                                            <label class="label-text required">Class</label>
                                                            <span *ngIf="!selectedSiteData" nz-icon nzType="sync"
                                                                nzTheme="outline" class="ml-2 cursor"
                                                                style="padding-bottom: 5px;"
                                                                (click)="syncClasses();"></span>
                                                        </div>
                                                        <nz-select nzShowSearch nzPlaceHolder="Select Class"
                                                            [nzDisabled]="selectedSiteData"
                                                            [nzLoading]="isLoadingQBOClass" [nzSize]="'default'"
                                                            formControlName="class" [nzSelectOnTab]="true"
                                                            (ngModelChange)="focusCategoryDD($event)">
                                                            <ng-container *ngIf="!isLoadingQBOClass">
                                                                <nz-option
                                                                    *ngFor="let TransClassName of listOfTransactionClass"
                                                                    [nzLabel]="TransClassName._uiLabel"
                                                                    [nzValue]="TransClassName.id"
                                                                    [nzDisabled]="TransClassName.isMapped || TransClassName.isActive === false">
                                                                </nz-option>
                                                            </ng-container>
                                                            <nz-option *ngIf="isLoadingQBOClass" nzCustomContent>
                                                                <span nz-icon nzType="loading"
                                                                    class="loading-icon"></span>
                                                                Loading Data...
                                                            </nz-option>
                                                        </nz-select>
                                                        <ng-template #classError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                select
                                                                class
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="categoryError">
                                                        <label class="label-text required">Category</label>
                                                        <nz-select #categoryDD nzShowSearch
                                                            nzPlaceHolder="Select Category" [nzSelectOnTab]="true"
                                                            [nzSize]="'default'" formControlName="category"
                                                            (ngModelChange)="focusProductDD($event)">
                                                            <nz-option *ngFor="let option of listOfCategory"
                                                                [nzLabel]="option.name"
                                                                [nzValue]="option.id"></nz-option>
                                                        </nz-select>
                                                        <ng-template #categoryError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                select
                                                                category
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>

                                            <div nz-col nzSpan="12">
                                                <label class="sub-form-title">Invoices (Investments)</label>
                                            </div>
                                            <div nz-col nzSpan="12">
                                                <label class="sub-form-title">Account Balance</label>
                                            </div>

                                            <div nz-col nzSpan="6">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="ProductError">
                                                        <label class="label-text required">Product/Service</label>
                                                        <nz-select #productDD nzShowSearch
                                                            nzPlaceHolder="Select Product/Service" [nzSize]="'default'"
                                                            formControlName="product"
                                                            (ngModelChange)="focusProcessFee($event)"
                                                            [nzSelectOnTab]="true">
                                                            <nz-option *ngFor="let item of listOfProductService"
                                                                [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
                                                        </nz-select>
                                                        <ng-template #ProductError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                enter
                                                                product/service
                                                                name
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>

                                            <div nz-col nzSpan="3">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="ProcessError">
                                                        <label class="label-text required">Process fee
                                                            %</label>
                                                        <input #processFee class="input-group" nz-input
                                                            formControlName="processFee" autocomplete="off" type="text"
                                                            mask="percent.2" suffix="%"
                                                            [dropSpecialCharacters]="false" />
                                                        <ng-template #ProcessError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                enter
                                                                process fee %
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                            <div nz-col nzSpan="3">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="nonAlcFeeError">
                                                        <label class="label-text required">Non-alc fee
                                                            %</label>
                                                        <input #nonAlcFeeFee class="input-group" nz-input
                                                            formControlName="nonAlcFee" autocomplete="off" type="text"
                                                            mask="percent.2" suffix="%"
                                                            [dropSpecialCharacters]="false" />
                                                        <ng-template #nonAlcFeeError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                enter
                                                                non-alc fee %
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>

                                            <div nz-col nzSpan="6">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="startingbalanceError">
                                                        <label class="label-text required">Starting
                                                            balance</label>
                                                        <!--mask="separator.2" [prefix]="_fS.siteForm.get('startingBalance').value ? '$' : ''"
                                                    thousandSeparator=","-->
                                                        <input #startingBalance class="input-group" nz-input
                                                            formControlName="startingBalance" autocomplete="off"
                                                            type="text"
                                                            (keypress)="_cS.checkDecimalNumbers($event, _fS.siteForm.get('startingBalance').value)"
                                                            (blur)="formatAmount(_fS.siteForm.get('startingBalance').value)" />
                                                        <ng-template #startingbalanceError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                enter
                                                                starting balance
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                            <div nz-col [nzSpan]="6">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="dateError">
                                                        <label class="label-text required">Date</label>
                                                        <mat-form-field
                                                            [ngClass]="isDateError || invalidDate ? 'invalidMatField' : ''"
                                                            class="matDateField">
                                                            <input type="hidden" formControlName="date"
                                                                [matDatepicker]="pickerMat" placeholder="Choose a date"
                                                                [max]="maxSiteDate" [min]="minSiteDate"
                                                                (dateChange)="todate($event.value)"
                                                                (ngModelChange)="_fS.siteForm.value.date ? isDateError = false : ''">
                                                            <input matInput type="text" [textMask]="mask"
                                                                [ngModel]="_fS.siteForm.get('date').value | date : _fS.siteForm.get('date').value !== null ?'MM/dd/yyyy' : ''"
                                                                [ngModelOptions]="{standalone: true}"
                                                                (ngModelChange)="todate($event)" />
                                                            <mat-hint>MM/DD/YYYY</mat-hint>
                                                            <mat-datepicker-toggle matSuffix [for]="pickerMat">
                                                            </mat-datepicker-toggle>
                                                            <mat-datepicker #pickerMat></mat-datepicker>
                                                        </mat-form-field>
                                                        <ng-template #dateError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                enter
                                                                date
                                                            </ng-container>

                                                        </ng-template>
                                                        <p *ngIf="invalidDate" style="color:red; font-size: 12px;">Date
                                                            must
                                                            be between 01/01/2010 to 12/31/2050
                                                        </p>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                        </ng-container>


                                        <ng-container *ngIf="SelectedSiteTab != SiteType.Supplier">
                                            <div nz-col nzSpan="3">
                                                <label class="label-text required">Site</label>
                                            </div>
                                            <div nz-col nzSpan="3">
                                                <label class="label-text required">Non-alc</label>
                                            </div>
                                            <div nz-col nzSpan="3">
                                                <label class="label-text required">Program Period </label>
                                            </div>
                                            <div nz-col nzSpan="15">
                                                <label class="label-text required">Tags</label>
                                            </div>
                                            <div nz-col nzSpan="3">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="statusError">

                                                        <nz-radio-group formControlName="status">
                                                            <label nz-radio nzValue="1">Visible</label>
                                                            <label nz-radio nzValue="0">Hidden</label>
                                                        </nz-radio-group>
                                                        <ng-template #statusError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                select
                                                                status
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                            <div nz-col nzSpan="3">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="statusError">

                                                        <nz-radio-group formControlName="nonAlcStatus">
                                                            <label nz-radio [nzValue]="true">Visible</label>
                                                            <label nz-radio [nzValue]="false">Hidden</label>
                                                        </nz-radio-group>
                                                        <ng-template #statusError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                select
                                                                non-alc status
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                            <div nz-col nzSpan="3">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="statusError">

                                                        <nz-radio-group formControlName="programVisibility">
                                                            <label nz-radio [nzValue]="true">Visible</label>
                                                            <label nz-radio [nzValue]="false">Hidden</label>
                                                        </nz-radio-group>
                                                        <ng-template #statusError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                select
                                                                non-alc status
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                            <div nz-col nzSpan="3">
                                                <nz-form-item>
                                                    <nz-form-control [nzErrorTip]="statusError">

                                                        <nz-radio-group formControlName="tagVisibility">
                                                            <label nz-radio [nzValue]="true">Visible</label>
                                                            <label nz-radio [nzValue]="false">Hidden</label>
                                                        </nz-radio-group>
                                                        <ng-template #statusError let-control>
                                                            <ng-container *ngIf="control.hasError('required')">Please
                                                                select
                                                                non-alc status
                                                            </ng-container>
                                                        </ng-template>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                        </ng-container>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </nz-tab>

                <nz-tab nzTitle="Program Period Details" [nzDisabled]="newSelectedSiteId==null"
                    *ngIf="SelectedSiteTab != 1">
                    <div class="page-padding">
                        <div nz-row class="d-flex align-i-c ">
                            <div nz-col nz-col nzXs="24" nzSm="24" nzMd="9" nzLg="9" nzXl="12">
                                <h1 class="page-title-text tab-title ">Program Period</h1>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="15" nzLg="15" nzXl="12">
                                <div class="d-flex justify-content-end ">
                                    <div class="mr-1 select-box-width">
                                        <nz-form-control nzErrorTip="Please input your username!">
                                            <nz-input-group nzPrefixIcon="search" class="search-input">
                                                <input [(ngModel)]="searchTextProgramP" (keyup)="searchProgram($event)"
                                                    nz-input placeholder="Search here..." />
                                            </nz-input-group>
                                        </nz-form-control>
                                    </div>
                                    <div>
                                        <button nz-button class="medium-btn" (click)="showDrawerProgramPeriod(null)"
                                            nzType="primary">
                                            <i nz-icon nzType="plus" nzTheme="outline"></i>
                                            New
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div nz-row>
                            <div nz-col nzSpan="24" class="section-top-padding">
                                <nz-table [nzScroll]="{y: 'calc(100vh - 22em)'}" [nzData]="getAllProgramPData"
                                    [nzOuterBordered]="true" [nzPageSize]="pageRecord" #apiProgramPeriodDataTable
                                    [(nzPageIndex)]="pageNumber" [nzTotal]="totalRecords" [nzHideOnSinglePage]="true"
                                    (nzPageIndexChange)="onQueryParamsChangeProgram($event)" [nzFrontPagination]="false"
                                    [ngClass]="{'table-loading' : isDataLoaded}">
                                    <thead>
                                        <tr class="th-bg-color">
                                            <ng-container *ngFor="let col of colsPrograms;let i=index">
                                                <th *ngIf="col.width && col.title != 'Action'" nz-resizable
                                                    nzBounds="window" [nzColumnKey]="col.sortTitle" nzPreview
                                                    [nzMinWidth]="50" [nzMaxWidth]="500" [nzWidth]="col.width"
                                                    (nzResizeEnd)="onResizePrograms($event, col.title)"
                                                    [nzAlign]="col.title == 'Default' ? 'center' : 'left'"
                                                    [ngClass]="col.sortTitle ? 'sortableCol' : ''">
                                                    {{ col.title }}
                                                    <nz-resize-handle nzDirection="right">
                                                        <div class="resize-trigger"></div>
                                                    </nz-resize-handle>
                                                </th>
                                                <th *ngIf="col.title == 'Action'" [nzWidth]="col.width"
                                                    nzAlign="center">
                                                    {{ col.title }}
                                                </th>
                                            </ng-container>
                                            <!-- <th >Program Label</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th [nzAlign]="'center'">Default</th>
                                        <th>Status</th>
                                        <th>Linked</th>
                                        <th class="center" nzWidth="100px">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="!isDataLoaded">
                                        <tr *ngFor="let data of apiProgramPeriodDataTable.data"
                                            (dblclick)="showDrawerProgramPeriod(data)">
                                            <td nzEllipsis [nzTooltipTitle]="data.label?.length > 8 ? data.label : ''"
                                                nzTooltipPlacement="bottomLeft" nz-tooltip>{{data.label}}</td>
                                            <td>{{data.shortStartMonth +', '+ data.startYear}}</td>
                                            <td>
                                                {{data.shortEndMonth +', '+ data.endYear}}
                                            </td>
                                            <td [nzAlign]="'center'">
                                                <nz-radio-group *ngIf="data.isVisible" [(ngModel)]="radioValue"
                                                    (ngModelChange)="makeProgramDefault($event)">
                                                    <label nz-radio [nzValue]="data.id"></label>
                                                </nz-radio-group>
                                            </td>
                                            <td>
                                                <nz-switch [disabled]="data.isDefault" [(ngModel)]="data.isVisible"
                                                    (ngModelChange)="updateProgramVisible(data)"></nz-switch>
                                            </td>
                                            <td><a class="link"
                                                    (click)="data.linked == 0 ? $event.preventDefault() : ''"
                                                    [href]="data.linked > 0 ? paybevEnvironmentUrl+'paybev/'+newSelectedSiteId+'/activity-detailed?t='+rToken+'&e='+currentUserEmail+'&program='+data.id : ''"
                                                    target="_blank">{{data.linked}}</a></td>
                                            <td class="center">
                                                <img src="/assets/images/edit.png" class="mr-1 cursor"
                                                    (click)="showDrawerProgramPeriod(data)">
                                                <img *ngIf="data.linked == 0 && !data.isDefault && !data.isVisible && !data.isUncategorized"
                                                    class="cursor" src="/assets/images/delete.png"
                                                    (click)="showDeleteConfirmProgramP(data)">
                                            </td>
                                        </tr>
                                    </tbody>
                                    <ng-container *ngIf="isDataLoaded">
                                        <tbody>
                                            <tr *ngFor="let i of [].constructor(8)">
                                                <ng-container *ngFor="let i of [].constructor(7)">
                                                    <td [nzAlign]="'left'" class="loading">
                                                        <div class="bar"></div>
                                                    </td>
                                                </ng-container>
                                            </tr>
                                        </tbody>
                                    </ng-container>
                                </nz-table>
                            </div>
                        </div>
                        <add-update-site-program-period [selectedProgramPeriodData]="selectedProgramPeriodData"
                            [selectedSiteId]="newSelectedSiteId" (hideProgramPeriodDrawer)="hideProgramPDrawer($event)"
                            *ngIf="isVisibleProgramPeriodDrawer">
                        </add-update-site-program-period>
                    </div>
                    <nz-modal [(nzVisible)]="deleteProgramPConfirmVisible" nzCentered
                        (nzOnCancel)="handleCancelProgramP()" [nzMaskClosable]="false">
                        <div class="confirm-modal">
                            <ng-container *nzModalContent class="cc">
                                <div class="close-icon center">
                                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                                </div>
                                <h4 class="confirm-modal-title center Font-Medium">Are You Sure?</h4>
                                <p class="confirm-modal-sub-title center Font-Regular">Once the
                                    <b>{{selectedProgramPeriodData.label}}</b> is deleted, it
                                    cannot be recovered.
                                </p>
                            </ng-container>
                            <div *nzModalFooter class="center border-none ant-drawer-footer">
                                <button nz-button nzType="default" (click)="handleCancelProgramP()"
                                    class="default-btn width-100 ">Cancel</button>
                                <button nz-button nzType="primary" (click)="deleteProgram()"
                                    [nzLoading]="loadingDeleteProgram"
                                    class=" medium-btn delete-btn width-100">Delete</button>
                            </div>
                        </div>
                    </nz-modal>

                </nz-tab>

                <nz-tab nzTitle="Tags" [nzDisabled]="newSelectedSiteId==null" *ngIf="SelectedSiteTab != 1">
                    <div class="page-padding">
                        <div nz-row class="d-flex align-i-c ">
                            <div nz-col nz-col nzXs="24" nzSm="24" nzMd="9" nzLg="9" nzXl="9">
                                <h1 class="page-title-text tab-title">Tags</h1>
                            </div>
                            <div nz-col nzXs="24" nzSm="24" nzMd="15" nzLg="15" nzXl="15">
                                <div class="d-flex justify-content-end ">
                                    <div class="mr-1 select-box-width">
                                        <nz-form-control nzErrorTip="Please input your username!">
                                            <nz-input-group nzPrefixIcon="search" class="search-input">
                                                <input [(ngModel)]="searchText" (keyup)="searchTag($event)" nz-input
                                                    placeholder="Search by tag name" />
                                            </nz-input-group>
                                        </nz-form-control>
                                    </div>
                                    <div class="NewDropDown">
                                        <a nz-dropdown nzType="primary" [nzDropdownMenu]="menu"
                                            class="addButton medium-btn">
                                            New
                                            <span nz-icon nzType="down"></span>
                                        </a>
                                        <nz-dropdown-menu #menu="nzDropdownMenu">
                                            <ul nz-menu nzSelectable>
                                                <li nz-menu-item (click)="VisibleTagGroup(null)">Tag Group</li>
                                                <li nz-menu-item (click)="VisibleTag(null, null)">Tag</li>
                                            </ul>
                                        </nz-dropdown-menu>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div nz-row>
                            <div nz-col nzSpan="24" class="section-top-padding">
                                <nz-table #nzTable [nzData]="tagGroupData" nzTableLayout="fixed"
                                    [nzHideOnSinglePage]="true" [nzPageSize]="pageRecord" [nzOuterBordered]="true"
                                    [nzFrontPagination]="false" [(nzPageIndex)]="pageNumber" [nzTotal]="totalRecords"
                                    [nzScroll]="tagGroupData.length > 0 ? {y: 'calc(100vh - 29em)'} : {}"
                                    (nzPageIndexChange)="onQueryParamsChangeTag($event)">
                                    <thead>
                                        <tr class="th-bg-color">
                                            <th nzWidth="85px"></th>
                                            <th nzWidth="800px" (nzSortOrderChange)="sort('Name',$event)"
                                                [(nzSortOrder)]="tagNameOrder" nz-resizable nzBounds="window"
                                                [nzColumnKey]="'Name'" nzPreview [nzMinWidth]="50" [nzMaxWidth]="900"
                                                (nzResizeEnd)="onResizeTags($event, 'Name')">Name
                                                <nz-resize-handle nzDirection="right">
                                                    <div class="resize-trigger"></div>
                                                </nz-resize-handle>
                                            </th>
                                            <th nzWidth="300px">Transactions</th>
                                            <th nzWidth="100px" class="center" nzWidth="100px">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="!isDataLoaded" cdkDropList (cdkDropListDropped)="drop($event)"
                                        [cdkDropListSortPredicate]="sortPredicateForDisableItem(tagGroupData)">
                                        <ng-container *ngFor="let tagGroup of tagGroupData; let i = index">
                                            <tr (dblclick)="!tagGroup?.isDefault ? VisibleTagGroup(tagGroup) : null"
                                                cdkDrag [cdkDragDisabled]="tagGroup?.isDefault">
                                                <td [nzExpand]="expandSet.has(tagGroup.id) && !tagGroup?.isDefault"
                                                    [nzShowExpand]="tagGroup.tags?.length > 0 && !tagGroup?.isDefault"
                                                    (nzExpandChange)="onExpandChange(tagGroup.id, $event)">
                                                    <span class="sorterContainer">
                                                        <span *ngIf="tagGroup.tags?.length > 0 && !tagGroup?.isDefault"
                                                            class="sorter mt-5" nz-icon nzType="drag"
                                                            nzTheme="outline"></span>
                                                    </span>
                                                </td>
                                                <td>
                                                    <div class="d-flex"> <span
                                                            [ngStyle]="{'background-color': tagGroup.color }"
                                                            class="tagGroupColor"></span> {{ tagGroup.name }}</div>
                                                </td>
                                                <td>
                                                    <a class="link"
                                                        (click)="tagGroup.count == 0 || tagGroup.count == null ? $event.preventDefault() : ''"
                                                        [href]="tagGroup.count != 0 || tagGroup.count != null ? paybevEnvironmentUrl+'paybev/'+newSelectedSiteId+'/activity-detailed?t='+rToken+'&e='+currentUserEmail+'&tag='+tagGroup.id : ''"
                                                        target="_blank">{{ tagGroup.count != null ? tagGroup.count : 0}}
                                                        Transactions</a>
                                                </td>
                                                <td>
                                                    <img *ngIf="!tagGroup.isDefault" src="/assets/images/edit.png "
                                                        class="mr-1 cursor" (click)="VisibleTagGroup(tagGroup)" />
                                                    <img *ngIf="  !tagGroup.isDefault" class="cursor"
                                                        src="/assets/images/delete.png "
                                                        (click)="showDeleteConfirm(tagGroup, tagGroup)" />
                                                </td>
                                            </tr>
                                            <tr
                                                [nzExpand]="expandSet.has(tagGroup.id) && tagGroup.tags?.length > 0 && !tagGroup.isDefault">
                                                <td [colSpan]="4"></td>
                                                <nz-table #nzTagTable [nzData]="tagGroup.tags" nzTableLayout="fixed"
                                                    [nzShowPagination]="false" [nzFrontPagination]="false">
                                    <tbody *ngIf="!isDataLoaded">
                                        <ng-container *ngFor="let data of nzTagTable.data">
                                            <tr>
                                                <td class="w-85"></td>
                                                <td class="w-800"><span class="tag-list"><span
                                                            [ngStyle]="{'background-color': tagGroup.color }"
                                                            style="width: 20px;height:30px"></span>&nbsp; {{ data.name
                                                        }}</span></td>
                                                <td class="w-300"><a class="link"
                                                        (click)="data.count == 0 || data.count == null ? $event.preventDefault() : ''"
                                                        [href]="data.count != 0 || data.count != null ? paybevEnvironmentUrl+'paybev/'+newSelectedSiteId+'/activity-detailed?t='+rToken+'&e='+currentUserEmail+'&tag='+data.id : ''"
                                                        target="_blank">{{ data?.count != null ? data?.count : 0 }}
                                                        Transactions</a></td>
                                                <td class="center w-100">
                                                    <img *ngIf="!tagGroup.isDefault" src="/assets/images/edit.png "
                                                        class="mr-1 cursor" (click)="VisibleTag(tagGroup, data)" />
                                                    <img *ngIf="!tagGroup.isDefault" class="cursor"
                                                        src="/assets/images/delete.png "
                                                        (click)="showDeleteConfirm(tagGroup, data)" />
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </nz-table>
                                </tr>
    </ng-container>
    </tbody>
    <ng-container *ngIf="isDataLoaded">
        <tbody>
            <tr *ngFor="let i of [].constructor(50)">
                <ng-container *ngFor="let i of [].constructor(4)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
    </nz-table>
    </div>
    </div>
    </div>
    <nz-modal [(nzVisible)]="deleteConfirmVisible" nzCentered (nzOnCancel)="handleCancelDelete()"
        [nzMaskClosable]="false">
        <div class="confirm-modal">
            <ng-container *nzModalContent class="cc">
                <div class="close-icon center">
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                </div>
                <h4 class="confirm-modal-title center Font-Medium">Are You Sure?</h4>
                <p class="confirm-modal-sub-title center Font-Regular">Once the
                    <b>{{selectedData.name}}</b> is deleted, it
                    cannot be recovered.
                </p>
            </ng-container>
            <div *nzModalFooter class="center border-none ant-drawer-footer">
                <button nz-button nzType="default" (click)="handleCancelDelete()"
                    class="default-btn width-100 ">Cancel</button>
                <button nz-button nzType="primary" class=" medium-btn delete-btn width-100"
                    (click)="deleteData()">Delete</button>
            </div>
        </div>
    </nz-modal>
    <!--tag group modal-->
    <!-- <nz-modal [(nzVisible)]="isVisibleTagGroup" [nzTitle]="groupTitle" [nzFooter]="footerTpl"
                    (nzOnCancel)="handleCancelTag()" [nzMaskClosable]="false" class="modal-padding-none"> -->


    <nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="500" nzCentered
        [(nzVisible)]="isVisibleTagGroup" [nzTitle]="groupTitle" (nzOnClose)="handleCancelTag()">

        <ng-container *nzDrawerContent>
            <form [formGroup]="_fS.tagsGroupForm" class="edit-tag-group">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                    <div nz-col nzXs="24" nzSm="20" nzMd="20" [nzLg]="isTagGroupAdded ? '24' : '20'"
                        [nzXl]="isTagGroupAdded ? '24' : '20'">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="tagGroupNameError">
                                <label class="label-text required">Tag Group Name</label>
                                <nz-input-group [nzPrefix]="isTagGroupAdded ? suffixIconSearch: ''">
                                    <input [ngClass]="isTagGroupAdded ? 'savedClass' : ''" class="input-group" nz-input
                                        formControlName="tagGroupName" minlength="2" maxlength="40"
                                        placeholder="Enter Group Name" [readonly]="isTagGroupAdded" />
                                </nz-input-group>
                                <ng-template #suffixIconSearch>
                                    <div class="tagGroupColor" [ngStyle]="{'background': color}"></div>
                                </ng-template>
                                <ng-template #tagGroupNameError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter group name
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Group name must contain at least
                                        2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="4" nzMd="4" nzLg="4" nzXl="4" *ngIf="!isTagGroupAdded">
                        <nz-form-item>
                            <nz-form-control>
                                <label class="label-text required">Color</label>
                                <nz-input-group [nzSuffix]="suffixIconArrow">
                                    <!-- <input [ngClass]="isTagGroupAdded ? 'savedClass' : ''" class="input-group" nz-input
                                                    formControlName="tagGroupName" minlength="2" maxlength="40"
                                                    placeholder="Enter Group Name" [readonly]="isTagGroupAdded" /> -->
                                    <div class="color-picker">
                                        <div class="summary-info" (click)="toggleColors()">
                                            <!-- <div class="info"> -->
                                            <!-- <p class="style">{{ heading }}</p> -->
                                            <!-- <p class="style-value">{{ color }}</p> -->
                                            <!-- </div> -->
                                            <div class="circle m-0" [ngStyle]="{'background': color}"></div>
                                        </div>
                                        <div class="opened" *ngIf="show">
                                            <div class="colors">
                                                <div (click)="changeColor(paint)" *ngFor="let paint of defaultColors"
                                                    [class]="'circle selected' + ' ' + paint.class"
                                                    [ngStyle]="{'background': paint.color}"
                                                    [ngClass]="paint.color == color ? 'selectedColor': ''"></div>
                                            </div>
                                            <div class="hex-code">
                                                <p>Hex Code</p>
                                                <div class="g-input">
                                                    <input type="text" maxlength="7" [value]="color"
                                                        (keyup)="changeColorManual(paintInput.value)" #paintInput
                                                        (keydown.enter)="toggleColors()" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </nz-input-group>
                                <ng-template #suffixIconArrow>
                                    <span nz-icon nzType="down" nzTheme="outline" (click)="toggleColors()"></span>
                                </ng-template>
                                <!-- <input class="input-group" nz-input type="color" formControlName="tagGroupColor" /> -->
                                <!-- <ng-template #tagGroupColorError let-control>
                                                <ng-container *ngIf="control.hasError('required')">Please select group color
                                                </ng-container>
                                            </ng-template> -->
                                <p *ngIf="color == ''" class="invalidtagname">Please select group color</p>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <button nz-button nzType="primary" (click)="addTagGroup()" *ngIf="!isTagGroupAdded"
                    [nzLoading]="isLoadingTagGroup">
                    Save
                </button>
            </form>
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="padding-add">
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <label class="label-text">Add Tags to this group</label>
                    <!-- <p *ngIf="!isTagGroupAdded">(save above tag group to add new tags)</p> -->
                    <div class="d-flex mb-2">
                        <input [disabled]="!isEnableButton" class="input-group mr-1" nz-input [(ngModel)]="tagname"
                            maxlength="40" />
                        <p *ngIf="invalidtagname" class="invalidtagname">Please enter tag name</p>
                        <button nz-button nzType="primary" (click)="addTagstoGroup()" [disabled]="!isEnableButton"
                            [nzLoading]="isLoadingTag">
                            Add
                        </button>
                    </div>

                </div>
            </div>
            <div class="d-flex flex-wrap">
                <div *ngFor="let tag of tags; let i=index;" class="m-1">
                    <span class="tag-list"><span class="tagsListColor"></span>
                        &nbsp; {{_fS.tagsGroupForm.get('tagGroupName').value + ': '}}&nbsp; <b>{{tag.name}}</b>
                        <span nz-icon nzType="close" nzTheme="outline" (click)="removeTag(i)"
                            class="cursor"></span></span>
                </div>
                <!-- <div *ngFor="let tag of tagsCopy; let i=index;" class="m-1">
                                <span class="tag-list"><span class="tagsListColor"></span>
                                    &nbsp; {{_fS.tagsGroupForm.get('tagGroupName').value + ': '}}&nbsp; <b>{{tag.name}}</b>
                                    <span nz-icon nzType="close" nzTheme="outline" (click)="removeTagFromTagsCopy(i)"
                                        class="cursor"></span></span>
                            </div> -->
            </div>
        </ng-container>
        <!-- <ng-template #footerTpl>
                        <div class="d-flex justify-content-end ">
                            <button nz-button nzType="primary"   *ngIf="isEnableButton" (click)="handleOkTag()" [nzLoading]="isLoadingTag"
                                class="medium-btn small-btn width-100 mr-1">{{ selectedTagGroupData != null ? "Update" : "Add" }}</button>
                            <button nz-button nzType="primary" *ngIf="isEnableButton" (click)="handleCancelTag()"
                                class="medium-btn cancel-btn width-100">Cancel</button>
                        </div>
                    </ng-template> -->
    </nz-drawer>
    <!--tag modal-->
    <nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="500" nzCentered
        [(nzVisible)]="isVisibleTag" [nzTitle]="tagTitle" [nzFooter]="tagfooterTpl"
        (nzOnClose)="handleCancelisVisibleTag()">

        <ng-container *nzDrawerContent>
            <form [formGroup]="_fS.tagForm">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 20, lg: 20 }">
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="tagNameError">
                                <label class="label-text required">Tag Name</label>
                                <input class="input-group" nz-input formControlName="tagName" minlength="2"
                                    maxlength="40" placeholder="Enter Tag Name" />
                                <ng-template #tagNameError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter tag name
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Tag name must contain at least 2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="tagGroupError">
                                <label class="label-text required">Tag Group Name</label>
                                <nz-select nzShowSearch nzPlaceHolder="Select Tag Group" [nzSize]="'default'"
                                    formControlName="tagGroup" [nzSelectOnTab]="true">
                                    <nz-option *ngFor="let option of listOfGroups" [nzLabel]="option.name"
                                        [nzValue]="option.id"></nz-option>
                                </nz-select>
                                <ng-template #tagGroupError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please select tag group
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
            </form>
        </ng-container>
        <ng-template #tagfooterTpl>
            <div class="d-flex justify-content-end ">
                <button nz-button nzType="primary" (click)="handleOkisVisibleTag()" [nzLoading]="isLoadingTag"
                    class="medium-btn small-btn width-100 mr-1">{{ selectedTagData != null ? "Update" : "Add"
                    }}</button>
                <button nz-button nzType="default" (click)="handleCancelisVisibleTag()"
                    class="default-btn width-100">Cancel</button>
            </div>
        </ng-template>
    </nz-drawer>


    </nz-tab>
    <nz-tab nzTitle="Preferred Partners" [nzDisabled]="newSelectedSiteId==null" *ngIf="SelectedSiteTab != 1">
        <div class="page-padding">
            <div nz-row class="d-flex align-i-c ">
                <div nz-col nz-col nzXs="24" nzSm="24" nzMd="9" nzLg="9" nzXl="9">
                    <h1 class="page-title-text">Preferred Partners</h1>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="15" nzLg="15" nzXl="15">
                    <div class="d-flex justify-content-end">
                        <div class="select-box-width">
                            <nz-input-group nzPrefixIcon="search" class="search-dropdown">
                                <nz-select nzShowSearch [nzDropdownClassName]="['disable-dropdown', 'customSelect']"
                                    nzPlaceHolder="Search in Database..." [(ngModel)]="inputValuePartner"
                                    class="w-280 hideArrow" nzShowSearch="true" (nzOnSearch)="searchPartner($event)"
                                    nzServerSearch [nzNotFoundContent]="renderinvestorTemplate">
                                    <ng-template></ng-template>
                                    <ng-container *ngIf="!isLoadingPartnerSearch">
                                        <nz-option *ngFor="let investor of partnerDBList"
                                            [nzLabel]="investor.companyName+' | '+investor.investorDisplayName"
                                            nzCustomContent [nzValue]="investor._id" nzDisabled>
                                            {{investor.companyName}} | {{investor.investorDisplayName}} <button
                                                nz-button nzType="primary" class="btn-option"
                                                (click)="addPartnerToList(investor)"
                                                [disabled]="investor.isAlreadyAdded"
                                                [nzLoading]="isDeletingInvestor && investor._id == currentAddingInvestor._id">
                                                {{!investor.isAlreadyAdded ? 'Add' : 'Added'}}
                                            </button></nz-option>
                                        <nz-option nzDisabled nzCustomContent *ngIf="partnerDBList?.length != 0"><a
                                                (click)="showDrawerPreferredPartners(null)"><i nz-icon nzType="plus"
                                                    nzTheme="outline" class="pr-1"></i>Create New Preferred
                                                Partner</a></nz-option>
                                    </ng-container>

                                    <nz-option *ngIf="isLoadingPartnerSearch" nzCustomContent>
                                        <span nz-icon nzType="loading" class="loading-icon"></span>
                                        Loading Data...
                                    </nz-option>

                                    <ng-template #renderinvestorTemplate>
                                        <span>No Preferred Partner found with the searched name. Create a New
                                            One!</span>
                                        <a class="create-new-btn" *ngIf="partnerDBList?.length == 0"
                                            (click)="showDrawerPreferredPartners(null)"><i nz-icon nzType="plus"
                                                nzTheme="outline"></i>Create New Preferred Partner</a>
                                    </ng-template>
                                </nz-select>
                            </nz-input-group>
                        </div>
                    </div>
                </div>
            </div>
            <div nz-row>
                <div nz-col nzSpan="24" class="section-top-padding">
                    <nz-table [nzPageSize]="pageSize" [nzOuterBordered]="true" [nzFrontPagination]="false"
                        [nzHideOnSinglePage]="true" [(nzPageIndex)]="page" [nzTotal]="totalRecords"
                        (nzPageIndexChange)="onQueryParamsChangePPartners($event)" [nzData]="getAllPPartnersData"
                        #getAllPartnerDataTable nzTableLayout="fixed" [nzScroll]="{y: 'calc(100vh - 23em)'}">
                        <thead>
                            <tr class="th-bg-color">
                                <ng-container *ngFor="let col of colsPartners;let i=index">
                                    <th *ngIf="col.width && col.title != 'Action'" nz-resizable nzBounds="window"
                                        [nzColumnKey]="col.sortTitle" nzPreview [nzMinWidth]="100" [nzMaxWidth]="400"
                                        [nzWidth]="col.width" [(nzSortOrder)]="col.sortDir"
                                        (nzSortOrderChange)="sortPartner(i, col.sortTitle || '', $event)"
                                        (nzResizeEnd)="onResizePartners($event, col.title)"
                                        [nzShowSort]="col.sortTitle ? true : false"
                                        [nzAlign]="col.title == 'Amount' || col.title == 'Fee' ? 'right' : 'left'"
                                        [ngClass]="col.sortTitle ? 'sortableCol' : ''">
                                        {{ col.title }}
                                        <nz-resize-handle nzDirection="right">
                                            <div class="resize-trigger"></div>
                                        </nz-resize-handle>
                                    </th>
                                    <th *ngIf="!col.width || col.title == 'Action'" [nzWidth]="col.width"
                                        nzAlign="center">
                                        {{ col.title }}
                                    </th>
                                </ng-container>
                                <!-- <th (nzSortOrderChange)="sortPartner('InvestorDisplayName')" [nzSortFn]="true" >Rep Name</th>
                                        <th>Address</th>
                                        <th (nzSortOrderChange)="sortPartner('PhoneNumber')"  [nzSortFn]="true">Phone No.</th>
                                        <th (nzSortOrderChange)="sortPartner('Email')" [nzSortFn]="true">Email</th>
                                        <th class="center" nzWidth="100px">Action</th> -->
                            </tr>
                        </thead>
                        <tbody *ngIf="!isDataLoaded">
                            <tr *ngFor="let data of getAllPartnerDataTable.data">
                                <td nzEllipsis
                                    [nzTooltipTitle]="(data.companyName+data.investorDisplayName)?.length > 15 ? (data.companyName+' | '+data.investorDisplayName) : ''"
                                    nzTooltipPlacement="bottomLeft" nz-tooltip="">
                                    {{data.companyName}} | {{data.investorDisplayName}}</td>
                                <td nzEllipsis
                                    [nzTooltipTitle]="(data.streetAddress1 + data.city  + data.state + data.zipCode + data.country).length > 16 ? addressTemplate   : ''"
                                    nzTooltipPlacement="bottomLeft" nz-tooltip>
                                    <span
                                        *ngIf="(data.streetAddress1!=null && data.streetAddress1!='') || (data.city!=null&& data.city!='' ) || ( data.state!=null && data.state!='' ) || (data.zipCode!=null && data.zipCode!='') || (data.country!=null && data.country!='') else elsepart "><span
                                            *ngIf="data.streetAddress1">{{data.streetAddress1}}</span><span
                                            *ngIf="data.streetAddress2">{{", "
                                            +data.streetAddress2}}</span><span *ngIf="data.city">{{", " +
                                            data.city}}</span><span *ngIf="data.state">{{ " , " +
                                            data.state}}</span><span *ngIf="data.zipCode">{{
                                            ", " + data.zipCode}}</span><span *ngIf="data.country">{{ (data.state ==
                                            null ? '' : ", ")
                                            + data.country}}</span>
                                    </span>
                                    <!-- {{data.streetAddress1 + " , " + data?.city + " , " + data?.state + " , " + data?.zipCode + " , " + data?.country }} -->
                                    <ng-template #addressTemplate let-event>
                                        <span
                                            *ngIf="(data.streetAddress1!=null && data.streetAddress1!='') || (data.city!=null&& data.city!='' ) || ( data.state!=null && data.state!='' ) || (data.zipCode!=null && data.zipCode!='') || (data.country!=null && data.country!='') else elsepart "><span
                                                *ngIf="data.streetAddress1">{{data.streetAddress1}}</span><span
                                                *ngIf="data.streetAddress2">{{" , "
                                                +data.streetAddress2}}</span><span *ngIf="data.city">{{"
                                                , " + data.city}}</span><span *ngIf="data.state">{{ " , " +
                                                data.state}}</span><span *ngIf="data.zipCode">{{
                                                " , " + data.zipCode}}</span><span *ngIf="data.country">{{ "
                                                , "
                                                + data.country}}</span>
                                        </span>
                                    </ng-template>
                                </td>
                                <td><span *ngIf="(data.phoneNumber != null && data.phoneNumber != '') else elsepart ">{{
                                        data.phoneNumber | mask : '(000) 000-0000' }} </span>

                                </td>
                                <td nzEllipsis [nzTooltipTitle]="data?.email?.length > 12 ? data?.email : ''"
                                    nzTooltipPlacement="bottomLeft" nz-tooltip>
                                    <span
                                        *ngIf="(data?.email != null && data?.email != '') else elsepart ">{{data?.email}}</span>
                                </td>
                                <td class="center">
                                    <!-- <img src="/assets/images/edit.png" class="mr-1 cursor"
                                                                                    (click)="showDrawerPreferredVendors(data)"> -->
                                    <img src="/assets/images/delete.png" class="cursor"
                                        (click)="showDeleteConfirmPPartners(data)">
                                </td>
                                <ng-template #elsepart let-event>
                                    <span>-</span>
                                </ng-template>
                            </tr>
                        </tbody>
                        <ng-container *ngIf="isDataLoaded">
                            <tbody>
                                <tr *ngFor="let i of [].constructor(8)">
                                    <ng-container *ngFor="let i of [].constructor(5)">
                                        <td [nzAlign]="'left'" class="loading">
                                            <div class="bar"></div>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </ng-container>
                    </nz-table>
                </div>
            </div>
            <add-update-site-preferred-partners [selectedPreferredPartnerData]="selectedPPartnerData"
                (hidePreferredPartnerDrawer)="hidePPartnerDrawer($event)" [selectedSiteId]="newSelectedSiteId"
                *ngIf="isVisiblePreferredPartnersDrawer">
            </add-update-site-preferred-partners>
        </div>
        <nz-modal [(nzVisible)]="deletePPartnersConfirmVisible" nzCentered (nzOnCancel)="handleCancelPPartners()"
            [nzMaskClosable]="false">
            <div class="confirm-modal">
                <ng-container *nzModalContent class="cc">
                    <div class="close-icon center">
                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                    </div>
                    <h4 class="confirm-modal-title center Font-Medium">Are You Sure?</h4>
                    <p class="confirm-modal-sub-title center Font-Regular">Once the
                        <b>{{selectedPreferredPartnersData.companyName}} |
                            {{selectedPreferredPartnersData.investorDisplayName}}</b> is deleted, it
                        cannot be recovered.
                    </p>
                </ng-container>
                <div *nzModalFooter class="center border-none ant-drawer-footer">
                    <button nz-button nzType="default" (click)="handleCancelPPartners()"
                        class="default-btn width-100 ">Cancel</button>
                    <button nz-button nzType="primary" class=" medium-btn delete-btn width-100"
                        (click)="deletePPartners()">Delete</button>
                </div>
            </div>
        </nz-modal>
    </nz-tab>
    <nz-tab nzTitle="Preferred Vendors" [nzDisabled]="newSelectedSiteId==null" *ngIf="SelectedSiteTab != 1">
        <div class="page-padding">
            <div nz-row class="d-flex align-i-c ">
                <div nz-col nz-col nzXs="24" nzSm="24" nzMd="9" nzLg="9" nzXl="9">
                    <h1 class="page-title-text">Preferred Vendors</h1>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="15" nzLg="15" nzXl="15">
                    <div class="d-flex justify-content-end">
                        <div class="select-box-width">
                            <nz-input-group nzPrefixIcon="search" class="search-dropdown">
                                <nz-select nzShowSearch [nzDropdownClassName]="['disable-dropdown', 'customSelect']"
                                    nzPlaceHolder="Search in Database..." [(ngModel)]="inputValue"
                                    class="w-280 hideArrow" nzShowSearch="true" [nzNotFoundContent]="renderTemplate"
                                    (nzOnSearch)="searchVendor($event)" nzServerSearch>
                                    <ng-container *ngIf="!isLoading">
                                        <nz-option *ngFor="let vendor of vendorsDBList"
                                            [nzLabel]="vendor.VendorDisplayName" nzCustomContent [nzValue]="vendor._id"
                                            nzDisabled>
                                            {{vendor.VendorDisplayName}} <button nz-button nzType="primary"
                                                class="btn-option" (click)="addVendorToList(vendor)"
                                                [nzLoading]="isDeletingVendor && vendor._id == currentAddingVendor._id"
                                                [disabled]="vendor?.IsAlreadyAdded == true">{{vendor?.IsAlreadyAdded ==
                                                true ? 'Added' : 'Add' }}
                                            </button></nz-option>
                                        <nz-option nzCustomContent nzDisabled *ngIf="vendorsDBList?.length != 0">
                                            <a (click)="showDrawerPreferredVendors(null)"><i nz-icon nzType="plus"
                                                    nzTheme="outline" class="pr-1"></i>Create New Vendor</a></nz-option>
                                    </ng-container>
                                    <nz-option *ngIf="isLoadingVendorSearch" nzCustomContent>
                                        <span nz-icon nzType="loading" class="loading-icon"></span>
                                        Loading Data...
                                    </nz-option>
                                    <ng-template #renderTemplate>
                                        <span>No vendor found with the searched name. Create a New One!</span>
                                        <a class="create-new-btn" *ngIf="vendorsDBList?.length == 0"
                                            (click)="showDrawerPreferredVendors(null)"><i nz-icon nzType="plus"
                                                nzTheme="outline"></i>Create New Vendor</a>
                                    </ng-template>
                                </nz-select>
                            </nz-input-group>
                        </div>
                    </div>
                </div>
            </div>
            <div nz-row>
                <div nz-col nzSpan="24" class="section-top-padding">
                    <nz-table [nzScroll]="{y: 'calc(100vh - 22em)'}" [nzData]="apiAllVendorsData"
                        [nzHideOnSinglePage]="true" [nzOuterBordered]="true" [nzPageSize]="pageRecord"
                        #apiAllVendorsDataTable [(nzPageIndex)]="pageNumber" [nzTotal]="totalRecords"
                        (nzPageIndexChange)="onQueryParamsChangePVendors($event)" [nzFrontPagination]="false"
                        [ngClass]="{'table-loading' : isDataLoaded}">
                        <thead>
                            <tr class="th-bg-color">
                                <ng-container *ngFor="let col of colsVendors;let i=index">
                                    <th *ngIf="col.width && col.title != 'Action'" nz-resizable nzBounds="window"
                                        [nzColumnKey]="col.sortTitle" nzPreview [nzMinWidth]="100" [nzMaxWidth]="400"
                                        [nzWidth]="col.width" [(nzSortOrder)]="col.sortDir"
                                        (nzSortOrderChange)="sortVendors(i, col.sortTitle || '', $event)"
                                        (nzResizeEnd)="onResizeVendors($event, col.title)"
                                        [nzShowSort]="col.sortTitle ? true : false"
                                        [nzAlign]="col.title == 'Amount' || col.title == 'Fee' ? 'right' : 'left'"
                                        [ngClass]="col.sortTitle ? 'sortableCol' : ''">
                                        {{ col.title }}
                                        <nz-resize-handle nzDirection="right">
                                            <div class="resize-trigger"></div>
                                        </nz-resize-handle>
                                    </th>
                                    <th *ngIf="!col.width || col.title == 'Action'" [nzWidth]="col.width"
                                        nzAlign="center">
                                        {{ col.title }}
                                    </th>
                                </ng-container>
                                <!-- <th (nzSortOrderChange)="sortVendors('VendorDisplayName')"  [nzSortFn]="true">Vendor Name</th>
                                        <th  >Address</th>
                                        <th (nzSortOrderChange)="sortVendors('PhoneNumber')" [nzSortFn]="true" >Phone No.</th>
                                        <th (nzSortOrderChange)="sortVendors('Email')" [nzSortFn]="true">Email</th>
                                        <th class="center" nzWidth="100px">Action</th> -->
                            </tr>
                        </thead>
                        <tbody *ngIf="!isDataLoaded">
                            <tr *ngFor="let data of apiAllVendorsDataTable.data">
                                <td nzEllipsis nzTooltipPlacement="bottomLeft" nz-tooltip>
                                    {{data.vendorDisplayName}}</td>
                                <td nzEllipsis
                                    [nzTooltipTitle]="(data.streetAddress1 + data.city  + data.state + data.zipCode + data.country)?.length > 16 ? addressTemplate   : ''"
                                    nzTooltipPlacement="bottomLeft" nz-tooltip>
                                    <span
                                        *ngIf="(data.streetAddress1!=null && data.streetAddress1!='') || (data.city!=null&& data.city!='' ) || ( data.state!=null && data.state!='' ) || (data.zipCode!=null && data.zipCode!='') || (data.country!=null && data.country!='') else elsepart "><span
                                            *ngIf="data.streetAddress1">{{data.streetAddress1}}</span><span
                                            *ngIf="data.streetAddress2">{{", " +data.streetAddress2}}</span><span
                                            *ngIf="data.city">{{", " + data.city}}</span><span *ngIf="data.state">{{ ",
                                            " +
                                            data.state}}</span><span *ngIf="data.zipCode">{{
                                            ", " + data.zipCode}}</span><span *ngIf="data.country">{{", "
                                            + data.country}}</span>
                                    </span>
                                    <!-- {{data.streetAddress1 + " , " + data?.city + " , " + data?.state + " , " + data?.zipCode + " , " + data?.country }} -->
                                    <ng-template #addressTemplate let-event>
                                        <span *ngIf="data.streetAddress1">{{data.streetAddress1}}</span><span
                                            *ngIf="data.streetAddress2">{{", " +data.streetAddress2}}</span><span
                                            *ngIf="data.city">{{", " +
                                            data.city}}</span><span *ngIf="data.state">{{ ", " +
                                            data.state}}</span><span *ngIf="data.zipCode">{{ ", " +
                                            data.zipCode}}</span><span *ngIf="data.country">{{
                                            ", " + data.country}}</span>
                                    </ng-template>
                                </td>
                                <td><span *ngIf="(data.phoneNumber != null && data.phoneNumber != '') else elsepart ">{{
                                        data.phoneNumber | mask : '(000) 000-0000' }} </span>

                                </td>
                                <td nzEllipsis [nzTooltipTitle]="data?.email?.length > 12 ? data.email : ''"
                                    nzTooltipPlacement="bottomLeft" nz-tooltip>
                                    <span
                                        *ngIf="(data.email != null && data.email != '') else elsepart ">{{data.email}}</span>
                                </td>
                                <td class="center">
                                    <!-- <img src="/assets/images/edit.png" class="mr-1 cursor"
                                                                                    (click)="showDrawerPreferredVendors(data)"> -->
                                    <img src="/assets/images/delete.png" class="cursor"
                                        (click)="showDeleteConfirmPVendors(data)">
                                </td>
                                <ng-template #elsepart let-event>
                                    <span>-</span>
                                </ng-template>
                            </tr>
                        </tbody>
                        <ng-container *ngIf="isDataLoaded">
                            <tbody>
                                <tr *ngFor="let i of [].constructor(8)">
                                    <ng-container *ngFor="let i of [].constructor(5)">
                                        <td [nzAlign]="'left'" class="loading">
                                            <div class="bar"></div>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </ng-container>
                    </nz-table>
                </div>
            </div>
            <app-add-update-site-preferred-vendors [selectedPreferredVendorsData]="selectedPreferredVData"
                [selectedSiteId]="newSelectedSiteId" (hidePreferredVendorsDrawer)="hidePVendorsDrawer($event)"
                *ngIf="isVisiblePreferredVendorsDrawer">
            </app-add-update-site-preferred-vendors>
        </div>
        <nz-modal [(nzVisible)]="deletePVendorsConfirmVisible" nzCentered (nzOnCancel)="handleCancelPVendors()"
            [nzMaskClosable]="false">
            <div class="confirm-modal">
                <ng-container *nzModalContent class="cc">
                    <div class="close-icon center">
                        <i nz-icon nzType="delete" nzTheme="outline"></i>
                    </div>
                    <h4 class="confirm-modal-title center Font-Medium">Are You Sure?</h4>
                    <p class="confirm-modal-sub-title center Font-Regular">Once the
                        <b>{{selectedPreferredVData.vendorDisplayName}}</b> is deleted, it
                        cannot be recovered.
                    </p>
                </ng-container>
                <div *nzModalFooter class="center border-none ant-drawer-footer">
                    <button nz-button nzType="default" (click)="handleCancelPVendors()"
                        class="default-btn width-100 ">Cancel</button>
                    <button nz-button nzType="primary" class=" medium-btn delete-btn width-100"
                        (click)="deletePVendors()">Delete</button>
                </div>
            </div>
        </nz-modal>
    </nz-tab>
    <nz-tab nzTitle="Non-alc" [nzDisabled]="newSelectedSiteId==null" *ngIf="SelectedSiteTab != 1">
        <div class="page-padding">
            <div nz-row class="d-flex align-i-c ">
                <div nz-col nz-col nzXs="24" nzSm="24" nzMd="9" nzLg="9" nzXl="9">
                    <h1 class="page-title-text">Non-alc Transactions</h1>
                </div>
                <div nz-col nz-col nzXs="24" nzSm="24" nzMd="14" nzLg="14" nzXl="14">
                    <div class="d-flex justify-content-end transactions-main-box">
                        <div class="mr-1" *ngIf="apiAllNonAlcData?.length > 0">
                            <nz-form-control>
                                <div class="export-btn" (click)="exportNonAlcCreditTransactions()">
                                    <button nz-button [disabled]="isExportingData"><img *ngIf="!isExportingData"
                                            src="assets/images/Excel-Icon.png"> <span *ngIf="isExportingData" nz-icon
                                            nzType="loading"></span> </button>
                                </div>
                            </nz-form-control>
                        </div>
                        <div class="transactions-box">
                            <label>Current balance</label>
                            <p>{{nonalcResult?.currentBalance | number: '1.2-2'}}</p>
                        </div>
                        <div class="transactions-box">
                            <label>Starting balance</label>
                            <div class="d-flex">
                                <p>{{nonalcResult?.startingBalance | number: '1.2-2'}}</p>
                                <!-- href="#" redirectStartingBalance() 
                                -->
                                <a class="ml-1"><a nz-popover nzPopoverTitle="Non-alc Starting Balance"
                                        [(nzPopoverVisible)]="isVisibleStartingBalancePopover" nzPopoverTrigger="click"
                                        [nzPopoverBackdrop]="false" nzPopoverPlacement="bottomRight"
                                        (nzPopoverVisibleChange)="change($event)"
                                        [nzPopoverContent]="contentTemplate"><img src="assets/images/edit-icon.svg"></a>
                                </a>
                                <ng-template #contentTemplate>
                                    <label>Enter Starting Balance</label>
                                    <input class="input-group" nz-input [(ngModel)]="startingBalanceNonAlc"
                                        [allowNegativeNumbers]="true" autocomplete="off" type="text" mask="separator.2"
                                        thousandSeparator="," [maxlength]="11" placeholder="Enter Starting Balance" />
                                    <div class="d-flex p-1">
                                        <button nz-button nzType="default"
                                            class="modal-footer-btn right_margin default-btn"
                                            (click)="isVisibleStartingBalancePopover=false;startingBalanceNonAlc=null">Cancel</button>
                                        <button class="btn-blue modal-footer-btn ml-1" nz-button nzType="primary"
                                            [disabled]="startingBalanceNonAlc==null || startingBalanceNonAlc.length < 1"
                                            (click)="updateNonalcDetails('balance')"
                                            [nzLoading]="isUpdatingDetails">Save</button>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                        <div class="transactions-box">
                            <label>Date</label>
                            <div class="d-flex">
                                <p>{{nonalcResult?.nonAlcDate?.toString().slice(0,-1).includes('0001') ?
                                    (today.toString().slice(0,-1) | date: 'MM/dd/yyyy') :
                                    (nonalcResult?.nonAlcDate.toString().slice(0,-1) | date: 'MM/dd/yyyy') }}</p>
                                <!-- href="#" (click)="redirectDate()"-->
                                <a class="ml-1"><a nz-popover nzPopoverTitle="Non-alc Date"
                                        [(nzPopoverVisible)]="isVisibleDatePopover" nzPopoverTrigger="click"
                                        [nzPopoverBackdrop]="false" nzPopoverPlacement="bottomRight"
                                        (nzPopoverVisibleChange)="change($event)"
                                        [nzPopoverContent]="contentTemplateDate"><img
                                            src="assets/images/edit-icon.svg"></a>
                                </a>
                                <!--<img src="assets/images/edit-icon.svg">-->
                                <ng-template #contentTemplateDate>
                                    <label>Enter Date</label>
                                    <nz-date-picker class="input-group"
                                        style="width: 100%;height: 45px;border-radius: 5px;" nz-input
                                        [nzFormat]="'MM/dd/yyyy'" (keypress)="preventDefaults($event)"
                                        [(ngModel)]="dateNonAlc" [nzAllowClear]="false">
                                    </nz-date-picker>
                                    <div class="d-flex p-1">
                                        <button nz-button nzType="default"
                                            class="modal-footer-btn right_margin default-btn"
                                            (click)="isVisibleDatePopover=false">Cancel</button>
                                        <button class="btn-blue modal-footer-btn ml-1" nz-button nzType="primary"
                                            (click)="updateNonalcDetails('date')"
                                            [nzLoading]="isUpdatingDetails">Save</button>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div nz-row>
                <div nz-col nzSpan="24" class="section-top-padding">
                    <nz-table [nzScroll]="totalRecords > 100 ? {y: 'calc(100vh - 24em)'} : {y: 'calc(100vh - 21em)'}"
                        [nzData]="apiAllNonAlcData" [nzOuterBordered]="true" [nzPageSize]="pageRecord"
                        #apiAllNonAlcDataTable [(nzPageIndex)]="pageNumber" [nzTotal]="totalRecords"
                        [nzHideOnSinglePage]="true" (nzPageIndexChange)="onQueryParamsChangeNonAlc($event)"
                        [nzFrontPagination]="false" [ngClass]="{'table-loading' : isDataLoaded}">
                        <thead>
                            <tr class="th-bg-color">
                                <ng-container *ngFor="let col of colsNonAlc;let i=index">
                                    <th *ngIf="col.width && col.title != 'Action'" nz-resizable nzBounds="window"
                                        [nzColumnKey]="col.sortTitle" nzPreview [nzMinWidth]="100" [nzMaxWidth]="400"
                                        [nzWidth]="col.width" [(nzSortOrder)]="col.sortDir"
                                        [nzShowFilter]="col.isFilterable"
                                        (nzSortOrderChange)="sortNonAlcData(i, col.sortTitle || '', $event)"
                                        (nzResizeEnd)="onResizeNonAlc($event, col.title)"
                                        [nzShowSort]="col.sortTitle ? true : false"
                                        [nzAlign]="col.title == 'Amount' || col.title == 'Fee' ? 'right' : 'left'"
                                        [ngClass]="{'sortableCol': col.sortTitle , 'filterableCol': col.isFilterable }"
                                        [nzCustomFilter]="col?.isFilterable && apiAllNonAlcData?.length">
                                        {{ col.title }}

                                        <nz-filter-trigger [nzDropdownMenu]="filterDropdown"
                                            [(nzVisible)]="col.isVisible"
                                            [nzActive]="selectedFilters[col.title]?.length > 0"
                                            (nzVisibleChange)="filterVisibleChange($event, col)">
                                            <span nz-icon nzTheme="fill" nzType="filter"></span>
                                        </nz-filter-trigger>

                                        <nz-dropdown-menu #filterDropdown="nzDropdownMenu">
                                            <div class="ant-table-filter-dropdown">
                                                <!-- <div class="search-box" *ngIf="!col.title.includes('Status')">
                                                    <nz-input-group nzPrefixIcon="search" class="search-input">
                                                        <input type="text" nz-input
                                                            (keyup)="searchFromFilterOptions(col)"
                                                            [placeholder]="'Search ' + col.title.toLowerCase()"
                                                            [(ngModel)]="filterSearchValue" />
                                                    </nz-input-group>
                                                </div> -->
                                                <nz-checkbox-group class="filterOptionsContainer"
                                                    [nzOptions]="col.filterOptions || []"
                                                    [(ngModel)]="col.selectedValues"></nz-checkbox-group>
                                                <div class="d-flex p-1">
                                                    <button nz-button nzSize="small"
                                                        [disabled]="col.filterOptions?.length == 0"
                                                        (click)="resetFilters(true,col.title)" nzType="default"
                                                        class="reset-btn mr-1">Reset</button>
                                                    <button nz-button nzSize="small"
                                                        [disabled]="col.filterOptions?.length == 0"
                                                        (click)="filterOK(col);">OK</button>
                                                </div>
                                            </div>
                                        </nz-dropdown-menu>

                                        <nz-resize-handle nzDirection="right">
                                            <div class="resize-trigger"></div>
                                        </nz-resize-handle>
                                    </th>
                                    <th *ngIf="!col.width || col.title == 'Action'" [nzWidth]="col.width"
                                        nzAlign="center">
                                        {{ col.title }}
                                    </th>
                                </ng-container>
                                <!-- <th (nzSortOrderChange)="sortVendors('ScheduleDate')" [nzSortFn]="true">Date</th>
                                        <th>Transaction No.</th>
                                        <th>Type</th>
                                        <th (nzSortOrderChange)="sortVendors('QBOEntityNo')" [nzSortFn]="true">Invoice No./Bill No.</th>
                                        <th (nzSortOrderChange)="sortVendors('CompanyName')" [nzSortFn]="true">Vendor</th>
                                        <th (nzSortOrderChange)="sortVendors('RepName')" [nzSortFn]="true">Supplier</th>
                                        <th >Debit</th>
                                        <th >Credit</th>
                                        <th class="center" nzWidth="100px">Action</th> -->
                            </tr>
                        </thead>
                        <tbody *ngIf="!isDataLoaded">
                            <tr *ngFor="let data of apiAllNonAlcDataTable.data" (dblclick)="showTransactionModal(data)">
                                <td nzEllipsis>{{data.date?.toString().slice(0,-1)?.includes('0001') ? '-' :
                                    data.date?.toString().slice(0,-1) | date: 'MM/dd/yyyy' }}</td>
                                <td>{{data?.transactionsType==1?(data?.isBalanceTransfer?'Transfer':'Investment'):data?.transactionsType==2?'Expense':'Expenses'}}
                                </td>
                                <td><span *ngIf="data.referenceNo">{{data.referenceNo}}</span><span
                                        *ngIf="!data.referenceNo">-</span></td>
                                <td nzEllipsis [nzTooltipTitle]="(data?.vendor)?.length > 12?data?.vendor:''"
                                    nzTooltipPlacement="bottomLeft" nz-tooltip>{{data?.vendor}}</td>

                                <td nzEllipsis [nzTooltipTitle]="(data?.supplier)?.length > 12?data.supplier:''"
                                    nzTooltipPlacement="bottomLeft" nz-tooltip><span
                                        *ngIf="data?.supplier else elsepart">{{data?.supplier}}</span></td>

                                <td><span *ngIf="data?.debitAmount else elsepart">
                                        {{data?.debitAmount | currency}}</span></td>
                                <td nzTooltipPlacement="bottomLeft"
                                    [nzTooltipTitle]="(data?.creditAmount)?.length > 5?data?.creditAmount:''" nzEllipsis
                                    nz-tooltip>{{data?.creditAmount | currency}}</td>
                                <td class="center">
                                    <img src="/assets/images/eye-icon.svg" class="cursor"
                                        (click)="showTransactionModal(data)">
                                </td>
                                <ng-template #elsepart let-event>
                                    <span>-</span>
                                </ng-template>
                            </tr>
                        </tbody>
                        <ng-container *ngIf="isDataLoaded">
                            <tbody>
                                <tr *ngFor="let i of [].constructor(8)">
                                    <ng-container *ngFor="let i of [].constructor(9)">
                                        <td [nzAlign]="'left'" class="loading">
                                            <div class="bar"></div>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </ng-container>
                    </nz-table>
                </div>
            </div>
            <!-- <app-add-update-site-preferred-vendors [selectedPreferredVendorsData]="selectedPreferredVData"
                        [selectedSiteId]="newSelectedSiteId" (hidePreferredVendorsDrawer)="hidePVendorsDrawer($event)"
                        *ngIf="isVisiblePreferredVendorsDrawer">
                    </app-add-update-site-preferred-vendors> -->

            <app-add-update-investments *ngIf="isVisibleInvestmentModal" [selectedData]="selectedData"
                (hideInvestmentDrawer)="hideEstimateDrawer($event)"></app-add-update-investments>
            <app-add-update-bills *ngIf="isVisibleBillModal" [selectedData]="selectedData"
                (hideExpenseDrawer)="hideEstimateDrawer($event)"></app-add-update-bills>
            <app-add-update-expense *ngIf="isVisibleExpenseModal" [selectedData]="selectedData"
                (hideExpenseDrawer)="hideEstimateDrawer($event)"></app-add-update-expense>
            <app-add-update-internal-transfer *ngIf="isVisibleITModal" [selectedData]="selectedData"
                (hideInternalTransferDrawer)="hideEstimateDrawer($event)"></app-add-update-internal-transfer>
            <app-add-update-credit *ngIf="isVisibleCreditModal" [selectedData]="selectedData"
                (hideCreditDrawer)="hideEstimateDrawer($event)"></app-add-update-credit>
            <app-add-update-refund *ngIf="isVisibleRefundModal" [selectedData]="selectedData"
                (hideRefundDrawer)="hideEstimateDrawer($event)"></app-add-update-refund>
            <app-add-update-deposit *ngIf="isVisibleDepositModal" [selectedData]="selectedData"
                (hideDepositDrawer)="hideEstimateDrawer($event)"></app-add-update-deposit>
        </div>

    </nz-tab>
    </nz-tabset>
    </div>
    </ng-container>
    <ng-template #footerTpl>
        <div *ngIf="this.tabIndex == 0" class="d-flex justify-content-end footer-box">
            <div class="ant-drawer-footer">
                <button nz-button nzType="default" (click)="handleCancel()" class="dlt-btn width-100">Close</button>
                <button *ngIf="SelectedSiteTab != SiteType.Supplier" nz-button nzType="primary" (click)="handleOk('')"
                    [nzLoading]="isLoadingOne" class="medium-btn width-100">{{selectedSiteData != null ? 'Update' :
                    'Save'}}</button>
                <button nz-button nzType="primary" (click)="handleOk('SAVECLOSE')" [nzLoading]="this.isLoadingSaveClose"
                    class="medium-btn small-btn width-100 ">{{selectedSiteData != null ? 'Update and Close' : 'Save and\
                    Close'}}</button>
            </div>
        </div>
    </ng-template>
</nz-modal>